const animItems = [
    // Главная
    // {
    //     selector: '.main-services .block-default__header',
    //     targets: [
    //         'header h2',
    //         {
    //             selector: 'header p',
    //             delayBase: 0.2,
    //             // anim: 'animate__fadeInLeft'
    //             // delayStep: .1
    //         }
    //     ],
    //     once: true
    // },
    {
        selector: '.main-about .wrapper',
        targets: [
            {
                selector: '.block-text > *',
                delayBase: 0.2,
                anim: 'animate__fadeInLeft',
                delayStep: 0.1
            }
        ],
        once: true
    },
    {
        selector: '.main-desc .wrapper',
        targets: [
            {
                selector: '.block-text > *',
                delayBase: 0.2,
                anim: 'animate__fadeIn',
                delayStep: 0.1
            },
            {
                selector: '.main-desc__item',
                delayBase: 0.4,
                delayStep: 0.1,
                anim: 'animate__fadeInUp'
            }
        ],
        once: true
    },
    {
        selector: '.block-projects .wrapper',
        targets: [
            {
                selector: '.block-text > *',
                delayBase: 0.2,
                anim: 'animate__fadeIn',
                delayStep: 0.1
            },
            {
                selector: '.block-projects__slider_item',
                delayBase: 0.4,
                delayStep: 0.1,
                anim: 'animate__fadeInUp'
            },
            {
                selector: '.block-default__foot > *',
                delayBase: 0.7,
                delayStep: 0.1,
                anim: 'animate__fadeIn'
            }
        ],
        once: true
    },
];

export default animItems;